const bannerConfigByCountry = {
  '24MX': { adUnit: 'MX_Inmuebles24/MX_Inmuebles24_MiCuenta_Leaderboard', sizes: [[728, 90]], dfpNetworkId: '1026403' },
  CAPA: {
    adUnit: 'PA_Compreoalquile/PA_Compreoalquile_MiCuenta_Leaderboard',
    sizes: [[728, 90]],
    dfpNetworkId: '1026403'
  },
  DVPE: { adUnit: 'PE_Adondevivir/PE_Adondevivir_MiCuenta_Leaderboard', sizes: [[728, 90]], dfpNetworkId: '1026403' },
  LLVE: { adUnit: 'VE_Conlallave/VE_Conlallave_MiCuenta_Leaderboard', sizes: [[728, 90]], dfpNetworkId: '1026403' },
  PLEC: { adUnit: 'EC_Plusvalia/EC_Plusvalia_MiCuenta_Leaderboard', sizes: [[728, 90]], dfpNetworkId: '1026403' },
  UBPE: { adUnit: 'PE_Urbania/PE_Urbania_MiCuenta_Leaderboard', sizes: [[728, 90]], dfpNetworkId: '1026403' },
  ZPAR: { adUnit: 'AR_Zonaprop/AR_Zonaprop_MiCuenta_Leaderboard-Top', sizes: [[728, 90]], dfpNetworkId: '1026403' },
  WIBR: {
    adUnit: 'Banner_CA',
    sizes: [[1180, 100]],
    dfpNetworkId: '8008544'
  },
  ICBR: {
    adUnit: 'Banner_CA',
    sizes: [[1180, 100]],
    dfpNetworkId: '8008544'
  },
  IWBR: {
    adUnit: 'Banner_CA',
    sizes: [[1180, 100]],
    dfpNetworkId: '8008544'
  },
  CMBR: {
    adUnit: 'Banner_CA',
    sizes: [[1180, 100]],
    dfpNetworkId: '8008544'
  },
  CACR: {
    adUnit: 'CR_Compreoalquile/CR_Compreoalquile_MiCuenta_Leaderboard',
    sizes: [[728, 90]],
    dfpNetworkId: '1026403'
  }
};

const siteId = process.env.REACT_APP_BUILD_SITE;

export const getConfigByCountry = () => bannerConfigByCountry[siteId];
